import React from 'react'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
const InterestSuggetionSuccess = ({ closeModal }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.suggestInterestContainer}>
      <button onClick={closeModal} className={styles.closePopin}>
        <Icon name='close24' />
      </button>
      <img className={styles.image} src={`${config.assetUrl}/images/emoji-nerd.png`} alt='' />

      <h2 className={styles.title}>{t('interestPicker.suggestInterestTitle')}</h2>
      <p className={styles.info}>{t('interestPicker.suggestInterestText')}</p>
      <Button text={t('global.ok')} handleClick={closeModal} />
    </div>
  )
}

export default InterestSuggetionSuccess
